import { createComponent } from '../lib';
import { VmMenu } from '@vime/core';
import { define } from '../lib';
define('vm-menu', VmMenu);
;
export default createComponent('vm-menu', new Set(['active', 'identifier', 'controller', 'slideInDirection']));
//# sourceMappingURL=Menu.jsx.map